export default {
      id: "menu__units-groups_fill-usage",
      viewBox: "0 0 21 16",
      url: __webpack_public_path__ + "img/icons.svg#menu__units-groups_fill",
      toString: function () {
        return this.url;
      }
    }